export enum PartitioningType {
    sicCrac = 'sic.crac',
    sicBxl = 'belfius.sicbxl',
    sicMandataire = 'sic.mandataire',
    sicPrevision = 'sic.prevision',
    citoyen = 'citoyen',
    bbc = 'bbc.2020',
    sicCrac2022 = 'sic.crac2022',
}
